export default [
	'Auto Parts',
	'Bank',
	'Big Box',
	'Car Wash',
	'Cellular Store',
	'Day Care/School',
	'Department Store',
	'Dollar Store',
	'Drug Store',
	'Dry Cleaner',
	'Education',
	'Entertainment',
	'Fast Food',
	'Farm & Ranch Supplier',
	'Fitness',
	'Gas/Convenience Store',
	'Grocery',
	'Home Improvement',
	'Mattress Store',
	'Medical',
	'Office Supply',
	'Other',
	'Pawn Shop',
	'Restaurant',
];